/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.modals.save.controllers', [])

.controller('ModalsSaveController', ['$scope', '$uibModalInstance', 'message', 'dontSaveButtonText', 'hideDontSave', 'saveButtonText', 'cancelButtonText', 'headingText', function($scope, $uibModalInstance, message, dontSaveButtonText, hideDontSave, saveButtonText, cancelButtonText, headingText) {

    $scope.modalsSave = {

      message: message,
      headingText: headingText,
      dontSaveButtonText: dontSaveButtonText,
      hideDontSave: hideDontSave,
      saveButtonText: saveButtonText,
      cancelButtonText: cancelButtonText,

      init: function() {},

      cancel: function() {
        $uibModalInstance.dismiss('close');
      },

      done: function(save) {
        $uibModalInstance.close(save);
      }

    };

    $scope.modalsSave.init();

}]);